import { gql } from '@apollo/client';

export const StateRdTaxCreditDocumentFragment = gql`
  fragment StateRdTaxCreditDocument on StateRdTaxCreditDocument {
    id
    state
    stateTaxCreditFormFileName
    stateTaxCreditFormUrl
    allowAccessDatetime
  }
`;
